import React from 'react'
import { cn } from '@/lib/utils'
import Timeago from '../../timeago'

class NavbarNotificationsPartial extends React.Component {

  onClick = () => {
    this.props.onOpen(this.props.notification)
  }

  render() {
    const notification = this.props.notification
    const notifier = notification.notifier

    let notifier_message = ''

    if (notifier) {
      notifier_message += notifier.name

      if (notification.of == 'task') {
        notifier_message += " assigned a task to you"
      }
      else if (notification.of == 'mail') {
        notifier_message += " mailed"
      }
      else if (notification.of == 'sms') {
        notifier_message += " SMSed"
      }
      else if (notification.of == 'message') {
        notifier_message += " messaged"
      }
    }

    return (
      <div
        className={cn(
          'flex cursor-pointer items-start gap-3 px-4 py-3 text-muted-foreground transition-colors odd:bg-muted/30 hover:bg-muted/60',
          !notification.opened_at && 'border-l-4 border-l-destructive pl-3'
        )}
        onClick={this.onClick}
      >
        {notifier ?
          <img className="size-9 shrink-0 rounded-full object-cover" src={notifier.profile_picture_url} alt=""/>
          : null
        }
        <div className="min-w-0 flex-1">
          <div className="flex items-baseline justify-between gap-2 text-sm font-semibold text-foreground">
            <span className="truncate">{notifier_message}</span>
            <small className="shrink-0 text-xs font-normal text-muted-foreground">
              <Timeago date={notification.created_at} />
            </small>
          </div>
          <p className="mt-0.5 truncate text-sm text-muted-foreground">{notification.content}</p>
        </div>
      </div>
    )
  }
}

export default NavbarNotificationsPartial
